import React from "react";
import { Snackbar, Alert } from "@mui/material";

const FavoriteSnackbar = ({ open, onClose, severity, message }) => (
  <Snackbar
    open={open}
    autoHideDuration={6000}
    anchorOrigin={{ vertical: "top", horizontal: "center" }}
    onClose={onClose}
  >
    <Alert
      onClose={onClose}
      severity={severity}
      variant="filled"
      sx={{ width: "100%" }}
    >
      {message}
    </Alert>
  </Snackbar>
);

export default FavoriteSnackbar;
